export const FaqClientActionTypes = {
    ASYNC_LIST: '@faqClient/ASYNC_LIST',
    SET_LIST: '@faqClient/SET_LIST',
    LOADING_LIST: '@faqClient/LOADING_LIST',
};

const INITIAL_STATE = {
    items: [],
    total: 0,
    loadingList: false,
}

export const FaqClient = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case FaqClientActionTypes.SET_LIST:
            return { ...state, items: payload?.items ?? [], total: payload?.total ?? 0 };
        case FaqClientActionTypes.LOADING_LIST:
            return { ...state, loadingList: payload };
        default:
            return state;
    }
}

export const asyncFaqClientList = (payload) => ({
    type: FaqClientActionTypes.ASYNC_LIST,
    payload,
});

export const setFaqClientList = (payload) => ({
    type: FaqClientActionTypes.SET_LIST,
    payload,
});

export const setFaqClientLoadingList = (payload) => ({
    type: FaqClientActionTypes.LOADING_LIST,
    payload,
});


export default FaqClient;